import ActionTypeFact from "../ActionTypeFact";

export default class CargaDeClientesBuscados extends ActionTypeFact {
    ejecutar(estado, nuevoEstado) {
        nuevoEstado.flag.procesandoComando = false;
        nuevoEstado.data = this.payload;
        return nuevoEstado;
    }
}
